import { apiFetch } from "./client";

const listUsers = async () => apiFetch("/api/users");

const createUser = async (payload) =>
  apiFetch("/api/users", {
    method: "POST",
    body: JSON.stringify(payload),
  });

const updateUser = async (id, payload) =>
  apiFetch(`/api/users/${id}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });

const resetUserPassword = async (id) =>
  apiFetch(`/api/users/${id}/reset-password`, {
    method: "POST",
  });

const deleteUser = async (id) =>
  apiFetch(`/api/users/${id}`, {
    method: "DELETE",
  });

export { listUsers, createUser, updateUser, resetUserPassword, deleteUser };
